module.exports = __webpack_public_path__ + "img/dundrum2_medium.50bb1cad.png";